// extracted by mini-css-extract-plugin
module.exports = {"GalleryCard":"gallery-card11_GalleryCard__3_fY1","image":"gallery-card11_image__1qM9D","text":"gallery-card11_text__8SX8g","text1":"gallery-card11_text1__25O5U"};